<template>
  <div :class="classes">
    <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber" :page-size="pageSize" :refresh="false" :current-page="currentPage" ref="table" isAddPageToRouter :isOutside="isOutside">
      <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" row-key="id">
        <el-table-column
          type="selection"
          width="55"
          fixed="left"
          :reserve-selection="true">
        </el-table-column>
        <el-table-column prop="name" label="节假日名称" min-width="180">
        </el-table-column>
        <el-table-column label="日期" min-width="180">
          <template slot-scope="scope">
            {{[scope.row.year,scope.row.month,scope.row.day].join('-')}}
          </template>
        </el-table-column>
        <el-table-column label="节假日类型" min-width="180">
          <template slot-scope="scope">
            {{formatHolidayType(scope.row.holidayType)}}
          </template>
        </el-table-column>
        <slot/>
      </el-table>
    </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
import { formatHolidayType } from '@/utils/enumeration/lab-order'
const prefixCls = 'pt-holiday-table'

export default {
  name: 'pt-holiday-table',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    }
  },
  props: {
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 31
    },
    currentPage: {
      type: Number,
      default: 0
    },
    isOutside: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatHolidayType,
    handleSelectionChange (val) {
      this.$emit('updateSelectedData', val)
    },
    resetPage () {
      this.$refs.table.resetPage()
    },
    showReTry () {
      this.$refs.table.showReTry()
    },
    getTableData (page, next) {
      this.$emit('getTableData', page, next)
    },
    load () {
      this.$refs.table.load()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
